import { render, staticRenderFns } from "./Payment.vue?vue&type=template&id=7896cf68&"
import script from "./Payment.vue?vue&type=script&lang=ts&"
export * from "./Payment.vue?vue&type=script&lang=ts&"
import style0 from "./Payment.vue?vue&type=style&index=0&id=7896cf68&prod&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Guidance: require('/opt/atlassian/pipelines/agent/build/components/guidance/Guidance.vue').default,PaymentMethod: require('/opt/atlassian/pipelines/agent/build/components/PaymentMethod.vue').default,PolicyContent: require('/opt/atlassian/pipelines/agent/build/components/PolicyContent.vue').default,Modal: require('/opt/atlassian/pipelines/agent/build/components/Modal.vue').default,TermsOfServiceContent: require('/opt/atlassian/pipelines/agent/build/components/TermsOfServiceContent.vue').default})
